var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.icons},[_c('Logo'),_c('span',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.$t("card"))),_c('br'),_vm._v(_vm._s(_vm.$t("of_foreign_bank"))+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }